import { useCallback } from 'react';
import { CanvasElementType, CanvasStandaloneNode } from '../canvas-types';
import { RfNodeStandalone } from '../canvas-types/nodeTypesData';
import { convertGridPositionToXYPosition } from '../helpers/gridPositioningUtils';
import { useDynamicNodeDimensions } from './useDynamicNodeDimensions';
import { STANDALONE_NODE_MIN_WIDTH } from '../nodes/StandaloneNode';
import { useSweepCanvasState } from '../internal-context/CanvasStateContext';
import { useSweepCanvasPropsCtx } from '../internal-context/SweepCanvasPropsCtx';
import { NODE_HEIGHT } from '../const';
import { adjustNodePositionForSection } from '../canvas-element-tool/helper';

const emptyStandaloneNodes: RfNodeStandalone[] = [];

export const useStandaloneNodesFactory = () => {
  const { zoomTransformSuffix } = useSweepCanvasState();
  const { onNodeClick, onConnectClick } = useSweepCanvasPropsCtx();
  const { getDynamicNodeDimensions } = useDynamicNodeDimensions({
    minWidth: STANDALONE_NODE_MIN_WIDTH,
  });

  const createFlowNodesFromSweepStandaloneNodes = useCallback(
    ({ standaloneNodes }: { standaloneNodes?: CanvasStandaloneNode[] }): RfNodeStandalone[] => {
      if (!standaloneNodes) {
        return emptyStandaloneNodes;
      }
      const nodes: RfNodeStandalone[] = [];

      standaloneNodes?.forEach((standaloneNode) => {
        const { width } = getDynamicNodeDimensions(standaloneNode.id);
        const position = convertGridPositionToXYPosition(standaloneNode.position);
        standaloneNode.sectionId && adjustNodePositionForSection(position);

        nodes.push({
          id: standaloneNode.id,
          type: CanvasElementType.STANDALONE_NODE,
          data: {
            name: standaloneNode.name,
            label: standaloneNode.type,
            icon: standaloneNode.icon,
            zoomTransformSuffix,
            topTag: standaloneNode.topTag,
            onNodeClick,
            onConnectClick,
            color: standaloneNode.color,
          },
          position,
          width,
          height: NODE_HEIGHT,
          parentId: standaloneNode.sectionId,
          expandParent: true,
        });
      });

      return nodes;
    },
    [getDynamicNodeDimensions, onConnectClick, onNodeClick, zoomTransformSuffix],
  );

  return {
    createFlowNodesFromSweepStandaloneNodes,
  };
};

export default useStandaloneNodesFactory;
